import { render, staticRenderFns } from "./InternalPage.vue?vue&type=template&id=dc2150de"
import script from "./InternalPage.vue?vue&type=script&lang=js"
export * from "./InternalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports